import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Response, URLSearchParams} from '@angular/http';
import {HttpMethod, Service} from '../common/service.class';
import {Model} from '../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class ProfileService extends Service {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'profile');
    }

    currentUserProfile<T extends Model<T>>(type: Model.Type<T>): Observable<T | undefined> {
        return this.get<T>(type, 'currentUser');
    }

    updateCurrentUserProfile(profile: Model<any>): Observable<Response> {
        return this.update(profile, 'currentUser');
    }

    doesProfileExistFor(npi: string): Observable<boolean> {
        const params = new URLSearchParams();
        params.set('npi', npi);
        return this.call('exists', params, undefined, HttpMethod.GET, true)
            .map(res => res.json().value);
    }

    doesAnotherProfileWithSameNpiExist(npi: string): Observable<boolean> {
        const params = new URLSearchParams();
        params.set('npi', npi);
        return this.call('currentUser/anotherExists', params, undefined, HttpMethod.GET, true)
            .map(res => res.json().value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/profile.service.ts